import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { ScrollToTop } from './components/ScrollToTop'
import { Home } from './pages/Home'

// Route-level code splitting: keep the top page (Home) in the initial bundle,
// lazy-load the rest so heavy deps (react-markdown, syntax highlighter used by
// BlogPost) are only fetched when their route is visited.
const Profile = lazy(() => import('./pages/Profile').then((m) => ({ default: m.Profile })))
const Products = lazy(() => import('./pages/Products').then((m) => ({ default: m.Products })))
const Talks = lazy(() => import('./pages/Talks').then((m) => ({ default: m.Talks })))
const Blog = lazy(() => import('./pages/Blog').then((m) => ({ default: m.Blog })))
const BlogPost = lazy(() => import('./pages/BlogPost').then((m) => ({ default: m.BlogPost })))
const TechSummaries = lazy(() => import('./pages/TechSummaries').then((m) => ({ default: m.TechSummaries })))
const TechSummaryPost = lazy(() => import('./pages/TechSummaryPost').then((m) => ({ default: m.TechSummaryPost })))
const Privacy = lazy(() => import('./pages/Privacy').then((m) => ({ default: m.Privacy })))
const EditorialPolicy = lazy(() => import('./pages/EditorialPolicy').then((m) => ({ default: m.EditorialPolicy })))

function RouteFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route
            path="/"
            element={
              <div className="min-h-screen bg-white">
                <Header />
                <main>
                  <Home />
                </main>
                <Footer />
              </div>
            }
          />
          <Route path="/profile" element={<Profile />} />
          <Route path="/products" element={<Products />} />
          <Route path="/talks" element={<Talks />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/tech" element={<TechSummaries />} />
          <Route path="/tech/:number" element={<TechSummaryPost />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/editorial-policy" element={<EditorialPolicy />} />
        </Routes>
      </Suspense>
      <Analytics />
    </BrowserRouter>
  )
}

export default App
